import { Option, Options } from "./types";

export const genOption =
  <T>(labelGenerator?: (value: T) => string) =>
  (value: T): Option<T> => ({
    value,
    label: labelGenerator ? labelGenerator(value) : value.toString(),
  });

export const getOption = <T>(options: Options<T>, value: T): Option<T> | null =>
  getOptionWithDefault(options, null)(value);

export const getOptionWithDefault =
  <T>(options: Options<T>, defaultValue: Option<T>) =>
  (value: T): Option<T> => {
    const index = options.findIndex(({ value: v }) => v === value);

    return index !== -1 ? options[index] : defaultValue;
  };

export const isOptionValueEqual =
  <T>(want: T) =>
  ({ value }: Option<T>): boolean =>
    want === value;
